/* eslint-disable import/first */
/* eslint-disable react/jsx-filename-extension */

// NOTE (jscheel): Do **not** put anything above these polyfills.
require('./polyfills')

import 'core-js/stable'
import 'regenerator-runtime/runtime'
// END NOTE

import config from 'config'
import createPlugin from 'bugsnag-react'
import { ThemeProvider } from '@emotion/react'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import * as runtime from 'offline-plugin/runtime' // eslint-disable-line import/no-extraneous-dependencies
import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader' // eslint-disable-line import/no-extraneous-dependencies
import { Provider } from 'react-redux'
import grooveTheme from '@groovehq/internal-design-system/lib/theme/groove'
import { GlobalStyles } from '@groovehq/internal-design-system/lib/styles/global'

import App from 'components/App'
import ListenToKeyboard from 'components/ListenToKeyboard'
import { refreshOnNextPage } from 'util/refreshMiddleware'

const app = require('./app')

import { runTriggers } from './triggers'

momentDurationFormatSetup(moment)

const offlineRuntime = process.env.OFFLINE_RUNTIME || 'on'

require('./util/cache_log').start()
require('./util/cache').watchForUpdate()

// fastclick to handle tap events on mobile out of the box
require('fastclick').attach(document.body)

require('./util/scrollbars').detectScrollbarType()

const container = document.getElementById('app')

const ErrorBoundary = bugsnagClient
  ? bugsnagClient.use(createPlugin(React))
  : props => <React.Fragment {...props} />

const render = MainComponent => {
  ReactDOM.render(
    <ErrorBoundary>
      <AppContainer>
        <Provider store={app.store}>
          <ThemeProvider theme={grooveTheme.light}>
            <GlobalStyles />
            <ListenToKeyboard.GlobalContextProvider>
              <MainComponent />
            </ListenToKeyboard.GlobalContextProvider>
          </ThemeProvider>
        </Provider>
      </AppContainer>
    </ErrorBoundary>,
    container
  )
}

render(App)

app.store.subscribe(runTriggers)
runTriggers()

if (!config.isTest) {
  const SEARCH_REFRESH_INTERVAL = 20 * 60000 // 15 minutes
  if (!localStorage.disableSearchRefresh) {
    setInterval(app.doRefreshCounts, SEARCH_REFRESH_INTERVAL)
  } else {
    //  eslint-disable-next-line no-console
    console.debug('search refresh disabled')
  }
}

// turns offline runtime off if manually set
if (offlineRuntime === 'on') {
  runtime.install({
    onUpdateReady: () => {
      // Tells to new SW to take control immediately
      runtime.applyUpdate()
    },
    onUpdated: () => {
      refreshOnNextPage()
    },
  })
}
// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./components/App', () => {
    render(App)
  })
}
